// removed by extract-text-webpack-plugin
module.exports = {"replyBtn":"_2tr44Yy_x2iO3oMoSAayP5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendReplyButton.scss
// module id = 1306
// module chunks = 1